export const mergedRefs = (...refs: any) => {
  const filteredRefs = refs.filter(Boolean);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 1) return filteredRefs[0];
  return (baseElement: any) => {
    for (const ref of filteredRefs) {
      if (typeof ref === 'function') {
        ref(baseElement);
      } else if (ref) {
        ref.current = baseElement;
      }
    }
  };
};
